
export const formatNumber = (n) => {
	const str = n.toString()
	return str[1] ? str : `0${str}`
}
// 过滤表情
export const filterEmoji = (name) => {
	const str = name.replace(
		/[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig,
		"");
	return str;
}
export const filterSpace = (name) => {

	const str = name.replace(/\s+/g, '');

	return str;

}
// 简陋版屏蔽二次点击事件重复触发
export const debounceEvent = (fn, wait = 500) => {
	let timer = null
	return function() {
		var context = this
		var args = arguments
		if (timer) return
		fn.apply(context, args);
		timer = setTimeout(() => {
			timer = null
			clearTimeout(timer)
		}, wait)
	}
}
/**
 * func 目标函数
 * delay 延迟执行毫秒数
 */
export function debounce(func, delay) {
	let timer;
	return function() {
		let context = this;
		let args = arguments;

		if (timer) {
			clearTimeout(timer);
		};
		timer = setTimeout(() => {
			func.apply(context, args);
		}, delay);
	};
};

// 定义一个深拷贝函数  接收目标target参数
export const deepClone = (source) => {
	// if (!isObject(source)) return source; //如果不是对象的话直接返回
	let target = Array.isArray(source) ? [] : {} //数组兼容
	for (var k in source) {
		if (source.hasOwnProperty(k)) {
			if (typeof source[k] === 'object') {
				target[k] = deepClone(source[k])
			} else {
				target[k] = source[k]
			}
		}
	}
	return target
}
export const formatDate = (date, middle = '-', hasTime = true) => {
	date = new Date(date)
	const year = date.getFullYear()
	const month = date.getMonth() + 1
	const day = date.getDate()

	const hour = date.getHours()
	const minute = date.getMinutes()
	const second = date.getSeconds()

	const t1 = [year, month, day].map(formatNumber).join(middle)
	const t2 = [hour, minute, second].map(formatNumber).join(':')

	return hasTime ? `${t1} ${t2}` : t1
}
export const formatArrToObject = (arr, key, value) => {
	let obj = {}
	if (Array.isArray(arr) && arr.length) {
		arr.forEach(el => {
			obj[el[key]] = el[value]
		})
	}
	return obj
}

/**
 * 后端活动字段映射为活动组件所需的 activity 对象（字段约定见 components/activityGoodsItem.vue 顶部注释）
 * 后端字段：is_activity 有效活动期、activity_price 现价、price 原价、activity_end_time 结束时间
 * 直降 = 原价 - 现价；非活动期或无现价返回 null
 */
export const mapGoodsActivity = (goods) => {
	if (!goods || Number(goods.is_activity) !== 1 || goods.activity_price == null) return null
	const price = Number(goods.activity_price) || 0
	const origin = Number(goods.price) || 0
	const activity = {
		price: goods.activity_price,
		end_time: goods.activity_end_time
	}
	if (origin > price) {
		activity.origin_prices = origin
		activity.discount_text = '直降¥' + Math.round((origin - price) * 100) / 100
	}
	return activity
}

export const getQueryVariable = (variable) => {
	var query = window.location.search.substring(1);
	var vars = query.split("&");
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split("=");
		if (pair[0] == variable) {
			return pair[1];
		}
	}
	return (false);
}

//检测是否需要更新
export const isUpdate = (curVersion, serVersion) => { // 判断是否需要更新
	let [serArray, curArray] = [serVersion.split(".").join(''), curVersion.split(".").join('')]
	return Number(curArray) < Number(serArray)
	// if (parseInt(serArray[0]) > parseInt(curArray[0])) {
	// 	return true
	// } else if (parseInt(serArray[1]) > parseInt(curArray[1])) {
	// 	return true
	// } else if (parseInt(serArray[1]) >= parseInt(curArray[1]) && parseInt(serArray[2]) > parseInt(curArray[
	// 		2])) {
	// 	return true
	// } else {
	// 	return false
	// }
}

//更新

export const doUpData = (downloadApkUrl) => {

	// var downloadApkUrl = that.downloadApkUrl;
	console.log(downloadApkUrl)
	var dtask = plus.downloader.createDownload(downloadApkUrl, {}, function(d,
		status) {
		// 下载完成  
		if (status == 200) {
			console.log("下载完成")
			plus.runtime.install(plus.io.convertLocalFileSystemURL(d
				.filename), {}, {}, function(
				error) {
				uni.showToast({
					title: '安装失败',
					duration: 1500
				});
			})
		} else {
			console.log("下载完成")
			uni.showToast({
				title: '更新失败',
				duration: 1500
			});
		}
	});
	//开始下载
	dtask.start();
	var prg = 0;
	var showLoading = plus.nativeUI.showWaiting("正在下载"); //创建一个showWaiting对象
	// 进度条
	dtask.addEventListener('statechanged', function(
		task,
		status
	) {
		// 给下载任务设置一个监听 并根据状态  做操作
		switch (task.state) {
			case 1:
				showLoading.setTitle("正在下载");
				break;
			case 2:
				showLoading.setTitle("已连接到服务器");
				break;
			case 3:
				prg = parseInt(
					(parseFloat(task.downloadedSize) /
						parseFloat(task.totalSize)) *
					100
				);
				showLoading.setTitle("  正在下载" + prg + "%  ");
				break;
			case 4:
				plus.nativeUI.closeWaiting();
				//下载完成
				break;
		}
	})
}
// 判断是否在微信浏览器内
export const isWechat = () => {
	// #ifdef H5
	let ua = window.navigator.userAgent.toLowerCase()
	if (ua.match(/MicroMessenger/i) == "micromessenger") {
		// wx.miniProgram.getEnv((res) => {
		//     if (res.miniprogram) {
		//         console.log('在小程序内');
		//     } else {
		//         console.log('不在小程序内');
		//     }
		// })
		console.warn('在微信浏览器内');
		return true
	} else {
		return false
		console.warn('不在微信浏览器内');
	}
	// #endif
	// #ifndef H5
	return false
	// #endif
}

// 检查系统定位服务（GPS开关）是否开启
// 返回 true=已开启 / false=未开启 / null=无法判断（非APP环境或API异常，调用方按开启处理）
export const isSystemLocationEnabled = () => {
	// #ifdef APP-PLUS
	try {
		const system = uni.getSystemInfoSync();
		if (system.platform === 'android') {
			const context = plus.android.importClass("android.content.Context");
			const locationManager = plus.android.importClass("android.location.LocationManager");
			const main = plus.android.runtimeMainActivity();
			const mainSvr = main.getSystemService(context.LOCATION_SERVICE);
			// GPS 或网络定位任一可用即视为开启了定位服务
			return mainSvr.isProviderEnabled(locationManager.GPS_PROVIDER)
				|| mainSvr.isProviderEnabled(locationManager.NETWORK_PROVIDER)
		}
		// iOS
		const CLLocationManager = plus.ios.importClass("CLLocationManager");
		return CLLocationManager.locationServicesEnabled()
	} catch (e) {
		console.log('isSystemLocationEnabled error', e)
		return null
	}
	// #endif
	// #ifndef APP-PLUS
	return null
	// #endif
}

// 打开系统设置位置权限
export const openSystemLocation = () => {
	const system = uni.getSystemInfoSync();
	if (system.platform === 'android') { // 判断平台
		// uni.openAppAuthorizeSetting()
		const context = plus.android.importClass("android.content.Context");
		
		const locationManager = plus.android.importClass("android.location.LocationManager");
		
		const main = plus.android.runtimeMainActivity();
		
		const mainSvr = main.getSystemService(context.LOCATION_SERVICE);
		
		const Intent = plus.android.importClass('android.content.Intent');
		
		const Settings = plus.android.importClass('android.provider.Settings');
		
		const intent = new Intent(Settings.ACTION_LOCATION_SOURCE_SETTINGS);
		
		main.startActivity(intent); // 打开系统设置GPS服务页面
	}
	else{
		plus.runtime.openURL("app-settings://");
	}
}

// 上次请求授权的时刻
export const LocationRefuseTimerKey = 'LocationRefuseTimer'
// 检查上次授权拒绝时间是否大于1小时
// true 可以继续授权了 false 则不可以授权了
export const checkRefuseLocaitonTimer = () => {
	const [nowDate, preDate] = [new Date().getTime(), uni.getStorageSync(LocationRefuseTimerKey)]
	if (preDate) {
		// 已经拒绝过 则判断时间是否大于1个小时
		if (nowDate - preDate > 3600*1000) {
			// 大于1小时了  可以再次提示了
			console.log("大于1小时了  可以再获取位置了")
			return true
		} else {
			// 小于1小时  不能再提醒了
			console.log("小于1小时  不能再获取位置了")
			return false
		}
	} else {
		// 没有设置过提醒
		console.log("没有拒绝过获取位置")
		return true
	}
}

// 若没有定位信息权限则判断用户是否要去打开位置权限
// must 是否立即提醒  false则过一段时间提醒
export const locationToastTimeKey = 'locationToastTime'
export const openSettingLocation = (must=false, callBack) => {
	if (must ===false) {
		const [nowDate, preDate] = [new Date().getTime(), uni.getStorageSync(locationToastTimeKey)]
		if (preDate) {
			// 已经提示过 则判断时间是否大于1个小时
			if (nowDate - preDate > 3600*1000) {
				// 大于1小时了  可以再次提示了
				console.log("大于1小时了  可以再次提示了")
				uni.setStorageSync(locationToastTimeKey, new Date().getTime())
			} else {
				// 小于1小时  不能再提醒了
				console.log("小于1小时  不能再提醒了")
				return
			}
		} else {
			// 没有设置过提醒
			console.log("没有获取过")
			uni.setStorageSync(locationToastTimeKey, new Date().getTime())
		}
	}
	
	//#ifdef APP-PLUS
	uni.showModal({
		title: "提示",
		content: "无法获取您的位置信息，为了便于查看您所在城市的服务项目和您与技师的距离，请检查位置权限是否打开。",
		confirmText: "去设置",
		success(confirm) {
			if (confirm.confirm) {
				callBack && callBack()
				uni.removeStorageSync(LocationRefuseTimerKey)
				uni.removeStorageSync(locationToastTimeKey)
				
				uni.openAppAuthorizeSetting()
				
			}
		}
	})
	
	// #endif
	//#ifndef APP-PLUS
	uni.showToast({
		title: "您已拒绝授权位置信息，无法获取到您的位置",
		icon: "none"
	})
	// #endif
}